import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Box, Typography, TextField, Button, Snackbar, styled,TextareaAutosize } from '@mui/material';
import { Email, Subject, Message, Send } from '@mui/icons-material';

const ContactForm = () => {
  const form = useRef<HTMLFormElement>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const serviceId = process.env.REACT_APP_SERVICE_ID || '';
  const templateId = process.env.REACT_APP_TEMPLATE_ID || '';
  const publicKey = process.env.REACT_APP_PUBLIC_KEY || '';

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.current) {
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
          console.log(result.text);
          console.log("Message sent");
          setSnackbarOpen(true);
          setSnackbarMessage('Message sent successfully!');
          // e.target.reset();
      }, (error) => {
          console.log(error.text);
          setSnackbarOpen(true);
          setSnackbarMessage('Failed to send message :(');
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fields = [
    {
      id: 'name',
      label: 'Name',
      type: 'text',
      name: 'user_name',
      startIcon: <Subject />,
    },
    {
      id: 'email',
      label: 'Email',
      type: 'email',
      name: 'user_email',
      startIcon: <Email />,
    },
  ];

  return (
    <Box sx={{ width: '100%', textAlign: 'left' }}>
      <Typography variant="h5" sx={{margin: '0 0 2rem 0', textAlign: {xs: "center", md: "left"}}}>Leave a message</Typography>
      <Box  
        component="form" 
        ref={form} 
        onSubmit={sendEmail}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          fontSize: '0.8rem',
        }}
      > 
        {fields.map((field) => (
          <StyledTextField
            key={field.id}
            fullWidth
            id={field.id}
            placeholder={field.label}
            type={field.type}
            name={field.name}
            variant="filled"
            sx={{
              margin: '0 0 1rem 0',
              minHeight: '3rem',
            }}
            InputProps={{
              disableUnderline: true,

            }}
          />
        ))}
        <StyledTextField 
            key='message'
            fullWidth
            id='message'
            placeholder='Message'
            type='text'
            name='message'
            variant="filled"
            multiline
            minRows={2}
            sx={{
              margin: '0 0 1rem 0',
              minHeight: '3rem',
              '& .MuiFilledInput-root': {
                paddingRight: '0',
                paddingLeft: '0'
              },
            }}
            InputProps={{
              disableUnderline: true,

            }}
          />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          value="Send"
          startIcon={<Send />}
          sx={{
            marginTop: '2rem',
            backgroundColor: '#f44336',
            padding: '0 1.5rem',
            color: 'white',
            minHeight: '3rem',
            '&:hover': {
              backgroundColor: '#e53935',
            },
            '&:active': {
              backgroundColor: '#d32f2f',
            },
          }}
        >
          Send Message
        </Button>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </Box>
  )
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: '#fff',
    fontSize: 'medium',
  },
  '& .MuiFormLabel-root': {
    fontSize: '1rem',
    '&.Mui-focused': {
      color: '#fff'
    },
  },
  '& .MuiInputBase-input': {
    textAlign: 'left',
    padding: '16px'
  },
  '& .MuiFilledInput-root': {
    border: '1px solid #fff',
    overflow: 'hidden',
    borderRadius: 4,
    color: '#fff',
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      boxShadow: `rgba(255, 255, 255, 0.2) 0 0 0 4px`,
      borderColor: '#fff',
      color: '#fff'
    },
  },
}));

export default ContactForm